import { GridModel } from "common/models/utility-models/list-utility.model";
import { BranchesModel } from "./branches-data-model";

export class BranchesGridModel extends BranchesModel {}

export class BranchesListingModel extends GridModel<BranchesGridModel> {}